// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sUtW","comment":"styles_comment__3qYDb"};